import { DynamicSx } from 'types';

export const formSx: DynamicSx<'formGroup'> = {
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
  },
};
